import moment from "moment";
import { useEffect, useState } from "react";

/* eslint-disable import/extensions */
import { getDiscordMostActiveMembers } from "../../lib/discordQueries";
/* eslint-disable import/extensions */
import { MostActiveMembersRpc } from "../../lib/discordTypes";

const defaultTimeFormat = "MM/DD/YY";

/**
 * Fetches the Discord most active members over a period of time
 *
 * @param startTime - start of time period
 * @param endTime - end of time period
 * @param guildId - the guild id
 * @param channelid - (optional) the channel id
 * @returns - An object with two properties --> data: the Discord most active members. isLoading: true when fetching data, false when done
 */
const useMostActiveMembers = (
  startTime: string,
  endTime: string,
  guildId: string | null,
  channelId?: string
) => {
  const [mostActiveMembers, setMostActiveMembers] = useState<
    MostActiveMembersRpc[] | null
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const workspaceId: string =
    JSON.parse(localStorage.getItem("supabase.auth.token") || "{}")
      ?.currentSession.user?.app_metadata.workspace || "";

  /**
   * Fetches the Discord most active members and sets the isLoading state
   */
  const loadData = async (): Promise<void | null> => {
    setLoading(true);
    if (!workspaceId) {
      setMostActiveMembers([]);
      setLoading(false);
      return;
    }

    let data;
    const params = {
      start_time: moment(startTime).format(defaultTimeFormat),
      end_time: moment(endTime).format(defaultTimeFormat),
      guild_id: guildId,
      workspace: workspaceId,
    };

    if (channelId) {
      data = await getDiscordMostActiveMembers(
        params.start_time,
        params.end_time,
        params.guild_id,
        params.workspace,
        channelId
      );
    } else {
      data = await getDiscordMostActiveMembers(
        params.start_time,
        params.end_time,
        params.guild_id,
        params.workspace
      );
    }

    setMostActiveMembers(data);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [startTime, endTime, channelId]);

  return { data: mostActiveMembers, isLoading: loading };
};

export default useMostActiveMembers;
